module.exports = __webpack_public_path__ + "img/6.a0f72c6b.png";